import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { Loader2, CheckCircle, XCircle } from 'lucide-react';
import { authApi } from '@/services/api';
import { useAuthStore } from '@/stores/auth';

export function EmailVerifyPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setAuth } = useAuthStore();
  const [verifyStatus, setVerifyStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setVerifyStatus('error');
      setErrorMessage('验证链接无效，缺少 token 参数。');
      return;
    }

    authApi.verifyEmail(token)
      .then((response) => {
        const { user, access } = response.data.data;
        setAuth(user, access);
        setVerifyStatus('success');
        setTimeout(() => navigate('/fsop'), 1500);
      })
      .catch((error) => {
        setVerifyStatus('error');
        setErrorMessage(
          error.response?.data?.message || '验证失败，链接可能已过期。'
        );
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (verifyStatus === 'loading') {
    return (
      <div className="text-center space-y-4 py-4">
        <Loader2 className="w-10 h-10 animate-spin text-blue-500 mx-auto" />
        <p className="text-gray-600">正在验证邮箱...</p>
      </div>
    );
  }

  if (verifyStatus === 'success') {
    return (
      <div className="text-center space-y-4 py-4">
        <CheckCircle className="w-12 h-12 text-green-500 mx-auto" />
        <h3 className="text-lg font-semibold text-gray-900">验证成功！</h3>
        <p className="text-gray-600 text-sm">正在跳转至主页面...</p>
      </div>
    );
  }

  return (
    <div className="text-center space-y-4 py-4">
      <XCircle className="w-12 h-12 text-red-400 mx-auto" />
      <h3 className="text-lg font-semibold text-gray-900">验证失败</h3>
      <p className="text-gray-600 text-sm">{errorMessage}</p>
      <Link to="/login" className="block text-blue-600 hover:text-blue-700 text-sm font-medium pt-2">
        返回登录
      </Link>
    </div>
  );
}
